// @flow

import React from "react";
import {
    Grid,
    Card,
    Table,
    Page,
    StatsCard,
    Form, Button
} from "tabler-react";
import "tabler-react/dist/Tabler.css";
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
// import SiteWrapper from "../SiteWrapper.client.react";
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import authActions from "../../redux/auth/action";
import clientService from "../../services/client";
import DownloadPopup from './downloadPopup';
import C3Chart from "react-c3js";
import '../../c3jscustom.css';
import 'c3/c3.css';
import * as d3 from 'd3'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MessageTrafficAnalytic from "./MessageTrafficAnalytic";
import TimeToAnswer from "./TimeToAnswer";
const _ = require('lodash');
const moment = require('moment');



export default class PaymentLogs extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            paymentLogs: {
                columns: [
                    ["PAY LATER", 0],
                    ["PAYMENT ABANDONED", 0],
                    ["PAYMENT SUCCESS", 0],
                    ["PAYMENT FAILURE", 0],
                    // ["Failed", 0], ["Success", 0]

                ],
                type: "donut",
            },
            startDateForPaymentLogs: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            endDateForPaymentLogs: new Date(),

        }
    }








    async getPaymentLogs(startDate, endDate) {
        var data = {
            columns: this.state.paymentLogs.columns.map(el => [el[0], 0]),
            type: 'donut',
        }

        await clientService.getPaymentLogs(startDate, endDate).then(res => {
            console.log("RESPONSE", res)
            let col = data.columns.map(el => {
                let data = res.data.find(ele => ele.paymentType === el[0])
                if (data && data.count) {
                    return [el[0], data.count]
                }
                return [el[0], 0]
            })
            // let col = data.columns.map(el => {
            //     let resobj = res.data.find(m => (m.status.charAt(0).toUpperCase() + m.status.slice(1)) == el[0]);
            //     if (resobj) {
            //         return ([el[0], resobj.count])
            //     }
            //     return el
            // })
            if (col.length) {
                data.columns = col;
            }
            console.log("dta", data)
            this.setState({ paymentLogs: data })
        }).catch(err => {
            console.log(err);
            this.setState({ paymentLogs: data })
        })
    }

    componentDidMount() {
        this.getPaymentLogs(this.state.startDateForPaymentLogs, this.state.endDateForPaymentLogs); //* Done
    }

    handlerAllChatDateChanger(type, event) {
        if (type === "startDateForPaymentLogs") {
            this.setState({ startDateForPaymentLogs: event })
        }
        if (type === "endDateForPaymentLogs") {
            this.setState({ endDateForPaymentLogs: event })
        }
    }

    DataChangePayment = async (e) => {
        e.preventDefault();
        this.getPaymentLogs(this.state.startDateForPaymentLogs, this.state.endDateForPaymentLogs, this.state.source);
    }

    tooltip_contentsForPaymentLogs(d, defaultTitleFormat, defaultValueFormat, color) {
        // console.log(d,defaultTitleFormat,defaultTitleFormat,color);
        var $$ = this, config = $$.config, CLASS = $$.CLASS,
            titleFormat = config.tooltip_format_title || defaultTitleFormat,
            nameFormat = config.tooltip_format_name || function (name) { return name; },
            valueFormat = config.tooltip_format_value || defaultValueFormat,
            text, i, title, value, name, bgcolor;

        for (i = 0; i < d.length; i++) {
            if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }

            // ADD
            if (d[i].name === 'data2') { continue; }


            if (!text) {
                title = 'MY TOOLTIP'
                text = "<table class='" + CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + d[i].name + "</th></tr>" : "");
            }
            name = nameFormat(d[i].name);
            value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
            bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

            text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
            text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Percentage" + "</td>";
            text += "<td class='value'>" + value + "</td>";
            text += "</tr>";

            text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
            text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Count" + "</td>";
            text += "<td class='value'>" + d[i].value + "</td>";
            text += "</tr>";
        }
        return text + "</table>";
    }



    render() {

        return (
            <>
                {/* paymentLogs  */}
                <div className="box-al mar-40">
                    <form onSubmit={this.DataChangePayment}>
                        <div className="row">
                            <div className="col col-6 col-sm-4 col-lg-5">
                                <label className="form-label">From Date</label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.startDateForPaymentLogs}
                                    onChange={(e) => this.handlerAllChatDateChanger("startDateForPaymentLogs", e)}
                                    // maxDate={this.state.endDateForPaymentLogs}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                    maxDate={new Date()}
                                />
                            </div>

                            <div className="col col-6 col-sm-4 col-lg-5">
                                <label className="form-label">To Date</label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.endDateForPaymentLogs}
                                    onChange={(e) => this.handlerAllChatDateChanger("endDateForPaymentLogs", e)}
                                    maxDate={new Date()}
                                    minDate={this.state.startDateForPaymentLogs}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                />
                            </div>

                            <div className="col col-6 col-sm-4 col-lg-2">
                                <br />
                                <Button color="primary   sub1" type="submit">
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col col-12 col-sm-12 col-lg-12">
                    <div className="box-3rd card card101">
                        <div className="bar-context row">
                            <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                                <h3 className="card-title"> Payment Logs </h3>
                            </div>
                        </div>
                        <div className="card-body p-3 text-center">
                            <C3Chart
                                data={this.state.paymentLogs}
                                // axis= {{
                                //     rotated: true,
                                //     x: {
                                //         type: 'category'
                                //     }
                                // }}
                                // tooltip= {{
                                //     grouped: false
                                // }}
                                legend={{
                                    show: true
                                }}
                                donut={{
                                    title: "Payment Logs"
                                }}
                                tooltip={{
                                    contents: this.tooltip_contentsForPaymentLogs
                                }}

                            // colors={{
                            //     Success: '#ff0000',
                            //     Failed: '#00ff00',
                            //     "PAY LATER": "PAY LATER",
                            //     "PAYMENT SUCCESS": "PAYMENT SUCCESS",
                            //     "PAYMENT FAILURE": "PAYMENT FAILURE",
                            //     "PAYMENT ABANDONED": "PAYMENT ABANDONED",
                            // }}


                            />

                        </div>
                        <div>
                        </div>
                    </div>
                </div>

            </>

        )
    }
}
